import axios from 'axios';
import { server } from '../serverUrl';
import { modal } from '../Components/ModalContext/ModalContext';

const getToken = () => localStorage.getItem('token');
const apiBaseUrl = server



const handleGetRequest = async (endpoint, navigate = null) => {
  const token = getToken();

  if (!token) {
    if (navigate) navigate('/login');
    return 'No authentication token found. Redirecting to login.';
  }

  try {
    const response = await axios.get(`${apiBaseUrl}/${endpoint}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.message === 'Network Error') {
      modal.openModal("Network Error. Please check your internet connection.");
      return 'Error: Network Error - Redirecting to login';
    }

    if (error.response) {
      const status = error.response.status;
      const message = error.response.data.message;

      if ((status === 401 && message?.includes('jwt expired')) || message?.includes('TokenExpiredError')) {
        modal.openModal("jwt expired");
        return 'Session expired. Redirecting to login.';
      }

      return `Error: ${message || 'Request Failed'}`;
    }

    return 'Network error. Please try again.';
  }
};
const handleRequest = async (endpoint, formData, navigate = null) => {
  const token = getToken();
  if (!token) {
    if (navigate) navigate('/login');
    return 'No authentication token found. Redirecting to login.';
  }

  try {
    const response = await axios.post(`${apiBaseUrl}/${endpoint}`, formData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.message === 'Network Error') {
      modal.openModal("Network Error. Please check your internet connection.");
      return 'Error: Network Error - Redirecting to login';
    }

    if (error.response) {
      const status = error.response.status;
      const message = error.response.data.message;

      if ((status === 401 && message?.includes('jwt expired')) || message?.includes('TokenExpiredError')) {
        if (navigate) navigate('/login');
        alert('jwt expired');
        return 'Session expired. Redirecting to login.';
      }

      return `Error: ${message || 'Request Failed'}`;
    }

    return 'Network error. Please try again.';
  }
};
const handleRequest2 = async (endpoint, formData, navigate = null) => {

  try {
    const response = await axios.post(`${apiBaseUrl}/${endpoint}`, formData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (error.message === 'Network Error') {
      modal.openModal("Network Error. Please check your internet connection.");
      return 'Error: Network Error - Redirecting to login';
    }

    if (error.response) {
      const status = error.response.status;
      const message = error.response.data.message;
      if ((status === 401 && message?.includes('jwt expired')) || message?.includes('TokenExpiredError')) {
        if (navigate) navigate('/login');
        alert('jwt expired');
        return 'Session expired. Redirecting to login.';
      }

      return error.response.data.error
    }

    return 'Network error. Please try again.';
  }
};
const handleLogout = (navigate) => {
  localStorage.clear()
  navigate("/");
  window.location.reload();
};
const requestsService = {
  CreateSaleDeedExtensionRequest: (formData, navigate) => handleRequest('CreateSaleDeedExtensionRequest', formData, navigate),
  getSaleDeedExtensionRequests: (formData, navigate) => handleGetRequest('getSaleDeedExtensionRequests', formData, navigate),
  order: (formData, navigate) => handleRequest2('createPaymentOrder', formData, navigate),
  validatePayment: (formData, navigate) => handleRequest2('validatePayment', formData, navigate),
  savePayments: (formData, navigate) => handleRequest2('savePayments', formData, navigate),
  generateAadharOtp: (formData, navigate) => handleRequest2('generateAadharOtp', formData, navigate),
  validateAadharOtp: (formData, navigate) => handleRequest2('validateAadharOtp', formData, navigate),

  // OC APIs (new)
  getSingleOc: (formData, navigate) => handleRequest('getSingleOc', formData, navigate),
  // Backward-compatible alias used in existing components
  getsocs: (formData, navigate) => handleRequest('getsocs', formData, navigate),
  // Public/flexible SOC lookup for QR code certificate download (uses auth if available, falls back to verify endpoint)
  getPublicSoc: async (formData) => {
    const token = getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    try {
      const response = await axios.post(`${apiBaseUrl}/getsocs`, formData, { headers });
      if (response?.data) return response.data;
    } catch (e) {
      // ignore and try fallback
    }
    const certId = formData?.certificateId || formData?.id;
    if (certId) {
      try {
        const verifyRes = await axios.get(`${apiBaseUrl}/verify-soc/${encodeURIComponent(certId)}`, { headers });
        if (verifyRes?.data?.details) return [verifyRes.data.details];
        if (verifyRes?.data) return [verifyRes.data];
      } catch (e) {
        // fallback failed
      }
    }
    return null;
  },
  // Public/flexible OC lookup for QR code certificate download
  getPublicOc: async (formData) => {
    const token = getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    try {
      const response = await axios.post(`${apiBaseUrl}/getocs`, formData, { headers });
      if (response?.data) return response.data;
    } catch (e) {
      // ignore and try fallback
    }
    const ocId = formData?.OCId || formData?.certificateId || formData?.id;
    if (ocId) {
      try {
        const kypRes = await axios.get(`${apiBaseUrl}/download-kyp/${encodeURIComponent(ocId)}`, { headers });
        if (kypRes?.data?.certificate) return [kypRes.data.certificate];
        if (kypRes?.data) return [kypRes.data];
      } catch (e) {
        // fallback failed
      }
    }
    return null;
  },

  handleLogout,
};
export default requestsService;

